<template>
	<div class="resources-list-wrapper" v-if="resourceData">
		<div class="resources-tags tags">
			<div 
			class="tag" 
			v-for="tag in resourceData.tags" 
			:key="tag.term_id" 
			@click="toggleTag(tag.slug)" 
			:class="{ active: activeTag === tag.slug }">
				{{ tag.name }}
			</div>
		</div>
		<div class="wspro-resources-list" :class="resource">
			<div 
			v-for="item in resourceData.posts" 
			:key="item.ID" 
			class="wspro-resources-list-item" 
			:data-id="item.ID"
			v-if="activeTag === false || resourceHasActiveTag(item.tags)">
				<a :href="resource === 'guides-and-downloads' ? item.pdf_url : 'resources/' + item.post_name">
					<img :src="item.thumbnail_url" :alt="item.post_title" class="resource-image" />
				</a>
				<div class="resource-content">
					<div class="tags">
						<div class="tag" v-for="tag in item.tags" :key="tag.term_id" :data-tag="tag.slug">{{ tag.name }}</div>
					</div>
					<h4>{{ item.post_title }}</h4>
					<div class="excerpt">{{ item.post_excerpt }}</div>
					<a v-if="resource === 'guides-and-downloads'" :href="item.pdf_url" target="_blank" class="download resource-button">Download</a>
					<a v-if="resource === 'walkthroughs'" :href="'resources/' + item.post_name" class="resource-button">View</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ResourcesList",
	props: ['resource', 'resourceData'],
	data() {
		return {
			activeTag: false
		}
	},
	methods: {
		toggleTag(tag) {
			if (this.activeTag !== tag) this.activeTag = tag;
			else this.activeTag = false;
		},
		resourceHasActiveTag(tags) {
			let contains = false;
			tags.forEach(function(tag) {
				if (tag.slug === this.activeTag) contains = true;
			}, this);
			return contains;
		}
	}
}
</script>

<style>

</style>